var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumberDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #4d9cd3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 24,
    cy: 24,
    r: 23
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.2,36.3c0,1.7,1.4,3.1,3.1,3.1h15.4c1.7,0,3.1-1.4,3.1-3.1v-18.5h3.1v-3.1h-6.2v-3.1c0-1.7-1.4-3.1-3.1-3.1h-9.2c-1.7,0-3.1,1.4-3.1,3.1v3.1h-6.2v3.1h3.1v18.5ZM19.4,11.7h9.2v3.1h-9.2v-3.1ZM17.8,17.8h13.9v18.5h-15.4v-18.5h1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.4,20.9h3.1v12.3h-3.1v-12.3ZM25.5,20.9h3.1v12.3h-3.1v-12.3Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberDelete);
export default __webpack_public_path__ + "static/media/numberDelete.f30603f438827aba3cf601cea060023c.svg";
export { ForwardRef as ReactComponent };